export default __webpack_public_path__ + "davinci-resolve-studio.7177adbf.png";